import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUser,
  FaClock,
  FaChevronLeft,
  FaShare,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DeatailBlog1 = () => {
  const blogPost = {
    id: 2,
    title:
      "Maîtrisez-vous le nouveau système comptable des entités à but non lucratif (SYSCEBNL) ?",
    excerpt:
      "Une révolution silencieuse pour les associations et ONG. Depuis le 1er janvier 2024, le SYSCEBNL transforme la comptabilité des entités à but non lucratif dans l'espace OHADA. Découvrez les enjeux et les risques de non-conformité.",
    content: `
      <p class="lead">Une révolution silencieuse pour les associations et ONG</p>
      
      <p>Depuis le 1er janvier 2024, une réforme comptable majeure est entrée en vigueur dans tout l'espace OHADA, mais elle est encore trop souvent méconnue des premiers concernés : les Entités à But Non Lucratif (EBNL). Son nom : le SYSCEBNL.</p>
      
      <p>Si vous dirigez une association, une Organisation Non Gouvernementale (ONG), un projet de développement, une fondation ou même une congrégation religieuse, ce n'est pas une simple mise à jour administrative. C'est un changement fondamental dans la manière dont vous devez présenter vos comptes, justifier vos financements et piloter votre organisation.</p>
      
      <p>En 2025, il n'est plus temps de s'interroger, il est temps d'être en pleine conformité. Votre organisation est-elle prête ?</p>
      
      <h3>1. Le SYSCEBNL, qu'est-ce que c'est et qui est concerné ?</h3>
      <p>Le Système Comptable des Entités à But Non Lucratif (SYSCEBNL) est un référentiel comptable standardisé, spécifiquement conçu pour les organisations qui ne poursuivent pas un but lucratif.</p>
      
      <h4>Qui est obligatoirement concerné ?</h4>
      <p>Toute entité de la zone OHADA qui correspond à la définition d'une EBNL, notamment :</p>
      <ul>
        <li>Les Associations et ONG locales et internationales ;</li>
        <li>Les projets de développement financés par des bailleurs de fonds ;</li>
        <li>Les fondations ;</li>
        <li>Les syndicats et ordres professionnels ;</li>
        <li>Les congrégations religieuses pour leurs activités non commerciales.</li>
      </ul>
      
      <p>L'objectif est simple : mettre fin aux comptabilités "maison" et instaurer un langage financier commun, fiable et transparent pour tout le secteur non-marchand.</p>
      
     <h3>
       <em>2. Pourquoi ce nouveau système ?</em><br />
       <span style="font-size: 0.9rem; font-style: normal; color: #555;">
         Les 3 piliers : Transparence, Fiabilité, Comparabilité
       </span>
     </h3>

      <p>L'adoption du SYSCEBNL n'est pas une contrainte pour le plaisir. Elle répond à des exigences de plus en plus fortes de la part des partenaires techniques et financiers (communément appelés "bailleurs de fonds").</p>
      
      <ol>
        <li><strong>La Transparence envers les bailleurs :</strong> Le SYSCEBNL impose de suivre l'utilisation des fonds par projet ou par financement. Il permet de répondre avec précision à la question cruciale de tout donateur : "Où est passé mon argent ?".</li>
        <li><strong>La Fiabilité de l'information financière :</strong> En imposant des règles strictes, le système garantit que les états financiers (bilan, compte de résultat, etc.) donnent une image fidèle de la santé financière et de la performance de l'entité.</li>
        <li><strong>La Comparabilité des organisations :</strong> Pour un bailleur de fonds qui doit choisir entre plusieurs projets, le SYSCEBNL permet de comparer des données financières sur une base identique, évaluant ainsi l'efficacité de chaque structure.</li>
      </ol>
      
      <h3>3. Les changements clés que vous devez maîtriser</h3>
      <p>Le SYSCEBNL introduit des concepts très différents de la comptabilité commerciale classique (SYSCOHADA).</p>
      
      <ul>
        <li><strong>La notion de "Fonds dédiés" :</strong> C'est le cœur de la réforme. Les subventions reçues pour un projet spécifique ne sont plus noyées dans les revenus généraux. Elles doivent être comptabilisées dans des "fonds dédiés" et leur utilisation doit être tracée pour prouver qu'elles ont bien servi à l'objet pour lequel elles ont été données.</li>
        <li><strong>La reconnaissance du bénévolat :</strong> Le nouveau système permet (sous certaines conditions) de comptabiliser les contributions en nature et le travail des bénévoles. Cela permet de montrer la véritable envergure des opérations de votre organisation, bien au-delà des seuls flux monétaires.</li>
        <li><strong>Des états financiers adaptés :</strong> Le SYSCEBNL propose des modèles d'états financiers spécifiques, comme le "Compte de résultat", qui distingue clairement les résultats liés aux activités de l'entité de ceux issus de l'utilisation des fonds dédiés.</li>
        <li><strong>Un plan de comptes spécifique :</strong> Oubliez le plan comptable général que vous connaissiez. Le SYSCEBNL a son propre plan de comptes (classes, numéros de compte) qu'il est impératif d'utiliser.</li>
      </ul>
      
      <h3>4. Le risque de la non-conformité est majeur !</h3>
      <p>Ignorer le SYSCEBNL expose votre organisation à des dangers critiques qui peuvent remettre en cause sa survie même.</p>
      
      <ul>
        <li><strong>Le risque n°1 : La perte de financements.</strong> C'est le danger le plus immédiat. Aucun bailleur de fonds sérieux ne financera une structure qui ne respecte pas les normes comptables en vigueur. La conformité au SYSCEBNL est en train de devenir un critère d'éligibilité non négociable.</li>
        <li><strong>Le risque de mauvaise gestion :</strong> Sans une comptabilité adaptée, il est impossible de piloter correctement votre organisation, d'anticiper les besoins de trésorerie ou de mesurer l'impact réel de vos actions.</li>
        <li><strong>Le risque juridique et réputationnel :</strong> Ne pas se conformer à une norme OHADA peut être considéré comme une faute de gestion de la part des dirigeants et ternir durablement la réputation de votre organisation.</li>
      </ul>
      
      <h3>Notre Rôle en tant qu'Expert-Comptable :</h3>
      <p>Face à ce défi technique, nous sommes votre partenaire pour :</p>
      <ol>
        <li>Réaliser un diagnostic de conformité de votre système actuel.</li>
        <li>Piloter la transition : Paramétrer votre logiciel comptable avec le nouveau plan de comptes et mettre en place les procédures de suivi des fonds dédiés.</li>
        <li>Former vos équipes financières et administratives aux nouvelles exigences.</li>
        <li>Externaliser la tenue de votre comptabilité pour vous garantir une conformité permanente et vous permettre de vous concentrer sur votre mission sociale.</li>
      </ol>
      
      <blockquote>
        "Le SYSCEBNL n'est pas une contrainte, mais une opportunité de professionnaliser la gestion de votre organisation, de renforcer la confiance avec vos partenaires et de pérenniser votre action."
      </blockquote>
      
      <h3>Faites de la conformité une force</h3>
      <p>Le SYSCEBNL n'est pas une contrainte, mais une opportunité de professionnaliser la gestion de votre organisation, de renforcer la confiance avec vos partenaires et de pérenniser votre action. La transparence et la rigueur sont aujourd'hui les clés pour accéder aux financements et maximiser votre impact social.</p>
      
      <h4 style={{ fontSize: '1rem', fontWeight: 'bold' }}>Votre association ou ONG est-elle pleinement conforme au SYSCEBNL ? Contactez notre cabinet dès aujourd'hui pour un diagnostic complet et un plan de mise en conformité sur mesure.</h4>
    `,
    image: "/assets/images/syscebnl-blog.jpg",
    categories: ["Comptabilité", "OHADA", "ONG"],
    tags: [
      "SYSCEBNL",
      "OHADA",
      "Associations",
      "ONG",
      "Comptabilité",
      "Fonds dédiés",
    ],
    date: "22 septembre 2025",
    author: "Expert CINEF-EC",
    authorTitle: "Expert-Comptable spécialisé OHADA",
    readTime: "8 min",
    featured: true,
  };

  const similarBlogs = [
    {
      id: 1,
      title:
        "Votre guide pour saisir les opportunités au Bénin : L'âge d'or des PME",
      image: "/assets/images/image1.png",
      date: "25 août 2025",
      category: "Développement",
    },
    {
      id: 3,
      title: "Optimisation fiscale avec la plateforme e-Services",
      image: "/assets/images/image8.png",
      date: "15 août 2025",
      category: "Fiscalité",
    },
  ];

  return (
    <>
      <Header />
      <div className="blog-content">
        <div className="container">
          <nav className="breadcrumb-container mb-4">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none">
                  Accueil
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/actualites/blog" className="text-decoration-none">
                  Blog
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {blogPost.title}
              </li>
            </ol>
          </nav>

          <div className="row">
            <div className="col-lg-8">
              <div className="blog-header mb-4">
                <div className="categories-badges mb-3">
                  {blogPost.categories.map((category, index) => (
                    <span key={index} className="category-badge me-2">
                      {category}
                    </span>
                  ))}
                </div>
                <h1 className="blog-title">{blogPost.title}</h1>

                <div className="blog-meta d-flex align-items-center mt-3">
                  <div className="meta-item d-flex align-items-center">
                    <FaCalendarAlt className="meta-icon" />
                    <span>{blogPost.date}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaUser className="meta-icon" />
                    <span>{blogPost.author}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaClock className="meta-icon" />
                    <span>{blogPost.readTime} de lecture</span>
                  </div>
                </div>
              </div>

              <div className="blog-excerpt mb-5">
                <p className="lead">{blogPost.excerpt}</p>
              </div>

              <div
                className="blog-body mb-5"
                dangerouslySetInnerHTML={{ __html: blogPost.content }}
              />

              <div className="blog-tags mb-4">
                {blogPost.tags.map((tag, index) => (
                  <Link key={index} to={``} className="blog-tag">
                    #{tag}
                  </Link>
                ))}
              </div>

              <div className="blog-share mb-5">
                <h5 className="share-title">Partager cet article</h5>
                <div className="social-buttons">
                  <a href="#" className="social-button linkedin">
                    <FaLinkedin />
                  </a>
                  <a href="#" className="social-button twitter">
                    <FaTwitter />
                  </a>
                  <a href="#" className="social-button facebook">
                    <FaFacebook />
                  </a>
                </div>
              </div>

              <div className="blog-actions mb-5">
                <Link to="/actualites/blog" className="btn btn-back">
                  <FaChevronLeft className="me-2" /> Retour au blog
                </Link>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="sidebar-widget author-widget">
                <h4 className="widget-title">À propos de l'auteur</h4>
                <div className="author-profile">
                  <div className="author-image">
                    <img
                      src="../assets/images/image5.png"
                      alt={blogPost.author}
                      className="img-fluid rounded-circle"
                    />
                  </div>
                  <div className="author-info">
                    <h5 className="author-name">{blogPost.author}</h5>
                    <p className="author-title">{blogPost.authorTitle}</p>
                    <p className="author-bio">
                      Expert-comptable certifié avec une spécialisation dans les
                      normes OHADA et le nouveau système comptable SYSCEBNL pour
                      les entités à but non lucratif.
                    </p>
                  </div>
                </div>
              </div>

              <div className="sidebar-widget similar-blogs-widget">
                <h4 className="widget-title">Articles similaires</h4>
                <div className="similar-blogs">
                  {similarBlogs.map((similarBlog) => (
                    <Link
                      key={similarBlog.id}
                      to={`/blog/${similarBlog.id}`}
                      className="similar-blog"
                    >
                      <div className="similar-blog-image">
                        <img
                          src={similarBlog.image}
                          alt={similarBlog.title}
                          className="img-fluid rounded"
                        />
                        <span className="category-badge small">
                          {similarBlog.category}
                        </span>
                      </div>
                      <div className="similar-blog-content">
                        <h5 className="similar-blog-title">
                          {similarBlog.title}
                        </h5>
                        <div className="similar-blog-date">
                          <FaCalendarAlt className="me-1" size={12} />
                          <small>{similarBlog.date}</small>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>

              <div className="sidebar-widget newsletter-widget">
                <h4 className="widget-title">Newsletter</h4>
                <p className="newsletter-desc">
                  Recevez nos conseils sur les réformes comptables OHADA et la
                  gestion des associations directement dans votre boîte mail
                </p>
                <form className="newsletter-form">
                  <div className="form-group mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Votre adresse email"
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">
                    S'abonner
                  </button>
                </form>
              </div>

              <div className="sidebar-widget categories-widget">
                <h4 className="widget-title">Ressources OHADA</h4>
                <ul className="categories-list">
                  <li>
                    <a
                      href="https://ohada.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Site officiel OHADA <span>→</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      Guide SYSCEBNL <span>→</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      Formation SYSCEBNL <span>→</span>
                    </a>
                  </li>
                  <li>
                    <Link to="/services/comptabilite-fiscalite">
                      Nos services <span>→</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Playfair+Display:wght@600;700;800&display=swap");

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .blog-content {
          background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
          padding: 3rem 0;
          font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
          color: #1a1a1a;
        }

        .breadcrumb {
          background: transparent;
          padding: 0;
          margin-bottom: 2.5rem;
          font-size: 0.9rem;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          color: #999;
          content: "›";
          padding: 0 0.5rem;
        }

        .breadcrumb-item a {
          color: #666;
          text-decoration: none;
          transition: color 0.2s;
        }

        .breadcrumb-item a:hover {
          color: #198754;
        }

        .breadcrumb-item.active {
          color: #1a1a1a;
          font-weight: 500;
        }

        .blog-header {
          margin-bottom: 3rem;
        }

        .categories-badges {
          display: flex;
          gap: 0.5rem;
          flex-wrap: wrap;
        }

        .category-badge {
          display: inline-block;
          background: linear-gradient(135deg, #198754 0%, #20c997 100%);
          color: white;
          padding: 0.4rem 1rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 0.3px;
          text-transform: uppercase;
        }

        .blog-title {
          font-family: "Playfair Display", serif;
          font-size: 2.8rem;
          font-weight: 800;
          line-height: 1.2;
          color: #1a1a1a;
          margin-top: 1rem;
          letter-spacing: -0.5px;
        }

        .blog-meta {
          display: flex;
          gap: 2rem;
          color: #666;
          font-size: 0.9rem;
          padding-top: 1rem;
          border-top: 1px solid #e8e8e8;
          margin-top: 1.5rem;
        }

        .meta-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .meta-icon {
          color: #198754;
          font-size: 0.9rem;
        }

        .blog-featured-image {
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
        }

        .blog-featured-image img {
          width: 100%;
          height: auto;
          display: block;
        }

        .blog-excerpt .lead {
          font-size: 1.3rem;
          font-weight: 400;
          line-height: 1.7;
          color: #444;
          border-left: 4px solid #198754;
          padding-left: 1.5rem;
          font-style: italic;
        }

        .blog-body {
          font-size: 1.05rem;
          line-height: 1.8;
          color: #333;
          text-align: justify;
        }

        .blog-body p {
          margin-bottom: 1.5rem;
        }

        .blog-body h3 {
          font-family: "Playfair Display", serif;
          font-size: 1.9rem;
          font-weight: 700;
          color: #1a1a1a;
          margin: 3rem 0 1.5rem 0;
          position: relative;
          padding-left: 1.5rem;
          border-left: 5px solid transparent;
          border-image: linear-gradient(to bottom, #dc3545, #198754) 1;
        }

        .blog-body h3:first-of-type {
          margin-top: 2rem;
        }

        .blog-body h4 {
          font-family: "Inter", sans-serif;
          font-size: 1.3rem;
          font-weight: 600;
          color: #2a2a2a;
          margin: 2rem 0 1rem 0;
        }

        .blog-body ul,
        .blog-body ol {
          margin: 1.5rem 0 1.5rem 1.5rem;
          padding-left: 1rem;
        }

        .blog-body li {
          margin-bottom: 0.8rem;
          padding-left: 0.5rem;
          position: relative;
        }

        .blog-body ul li::marker {
          color: #198754;
          font-size: 1.2rem;
        }

        .blog-body ol {
          counter-reset: item;
          list-style: none;
        }

        .blog-body ol li {
          padding-left: 2.5rem;
          position: relative;
          counter-increment: item;
        }

        .blog-body ol li::before {
          content: counter(item, upper-alpha);
          position: absolute;
          left: 0;
          top: 0;
          background: linear-gradient(135deg, #dc3545, #198754);
          color: white;
          width: 1.8rem;
          height: 1.8rem;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 0.85rem;
        }

        .blog-body strong {
          color: #1a1a1a;
          font-weight: 600;
        }

        .blog-body blockquote {
          background: linear-gradient(
            135deg,
            rgba(25, 135, 84, 0.05),
            rgba(220, 53, 69, 0.05)
          );
          border-left: 5px solid #198754;
          padding: 2rem;
          margin: 2.5rem 0;
          font-style: italic;
          font-size: 1.15rem;
          line-height: 1.7;
          color: #2a2a2a;
          border-radius: 0 8px 8px 0;
          position: relative;
        }

        .blog-body blockquote::before {
          content: '"';
          position: absolute;
          top: -10px;
          left: 15px;
          font-size: 4rem;
          color: #198754;
          opacity: 0.3;
          font-family: Georgia, serif;
        }

        .blog-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.6rem;
          padding: 1.5rem 0;
          border-top: 1px solid #e8e8e8;
        }

        .blog-tag {
          display: inline-block;
          background: #f5f5f5;
          color: #555;
          padding: 0.4rem 1rem;
          border-radius: 20px;
          text-decoration: none;
          font-size: 0.85rem;
          font-weight: 500;
          transition: all 0.3s ease;
          border: 1px solid #e8e8e8;
        }

        .blog-tag:hover {
          background: #198754;
          color: white;
          border-color: #198754;
          transform: translateY(-2px);
        }

        .blog-share {
          padding: 2rem 0;
          border-top: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
        }

        .share-title {
          font-size: 1rem;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 1rem;
        }

        .social-buttons {
          display: flex;
          gap: 1rem;
        }

        .social-button {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: all 0.3s ease;
          font-size: 1.1rem;
        }

        .social-button:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }

        .linkedin {
          background: #0077b5;
        }

        .twitter {
          background: #1da1f2;
        }

        .facebook {
          background: #4267b2;
        }

        .btn-back {
          display: inline-flex;
          align-items: center;
          background: white;
          color: #333;
          padding: 0.8rem 1.8rem;
          border-radius: 25px;
          text-decoration: none;
          border: 2px solid #e8e8e8;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .btn-back:hover {
          background: #198754;
          color: white;
          border-color: #198754;
          transform: translateX(-5px);
        }

        .sidebar-widget {
          background: white;
          border-radius: 12px;
          padding: 2rem;
          margin-bottom: 2rem;
          box-shadow: 0 2px 15px rgba(0, 0, 0, 0.04);
          border: 1px solid #f0f0f0;
        }

        .widget-title {
          font-family: "Playfair Display", serif;
          font-size: 1.4rem;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #f0f0f0;
          position: relative;
        }

        .widget-title::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 60px;
          height: 2px;
          background: linear-gradient(to right, #dc3545, #198754);
        }

        .author-profile {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .author-image {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          overflow: hidden;
          margin-bottom: 1rem;
          border: 3px solid #f0f0f0;
        }

        .author-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .author-name {
          font-size: 1.1rem;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 0.3rem;
        }

        .author-title {
          font-size: 0.9rem;
          color: #198754;
          font-weight: 500;
          margin-bottom: 1rem;
        }

        .author-bio {
          font-size: 0.9rem;
          color: #666;
          line-height: 1.6;
        }

        .similar-blogs {
          display: flex;
          flex-direction: column;
          gap: 1.2rem;
        }

        .similar-blog {
          display: flex;
          text-decoration: none;
          color: inherit;
          background: #fafafa;
          border-radius: 10px;
          overflow: hidden;
          transition: all 0.3s ease;
          border: 1px solid #f0f0f0;
        }

        .similar-blog:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
          border-color: #198754;
        }

        .similar-blog-image {
          width: 110px;
          height: 80px;
          flex-shrink: 0;
          position: relative;
        }

        .similar-blog-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .similar-blog-image .category-badge {
          position: absolute;
          top: 0.4rem;
          left: 0.4rem;
          padding: 0.2rem 0.6rem;
          font-size: 0.7rem;
          border-radius: 15px;
        }
        .similar-blog-content {
          padding: 0.6rem 1rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .similar-blog-title {
          font-size: 1rem;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 0.4rem;
        }
        .similar-blog-date {
          display: flex;
          align-items: center;
          color: #666;
          font-size: 0.85rem;
        }
        .newsletter-desc {
          font-size: 0.9rem;
          color: #555;
          margin-bottom: 1rem;
        }
        .newsletter-form .form-control {
          border-radius: 30px;
          border: 1px solid #e8e8e8;
          padding: 0.75rem 1.5rem;
          font-size: 0.95rem;
          transition: border-color 0.2s;
        }
        .newsletter-form .form-control:focus {
          border-color: #198754;
          box-shadow: 0 0 5px rgba(25, 135, 84, 0.3);
          outline: none;
        }
        .newsletter-form .btn {
          border-radius: 30px;
          padding: 0.75rem 1.5rem;
          font-size: 1rem;
          font-weight: 600;
          transition: all 0.3s ease;
          border: none;
        }
        .newsletter-form .btn:hover {
          background: #198754;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }
        .categories-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .categories-list li {
          margin-bottom: 1rem;
        }
        .categories-list li a {
          text-decoration: none;
          color: #1a1a1a;
          font-size: 0.95rem;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: color 0.2s;
        }
        .categories-list li a:hover {
          color: #198754;
        }
        .categories-list li a span {
          font-size: 1.2rem;
          transition: transform 0.2s;
        }
        .categories-list li a:hover span {
          transform: translateX(5px);
        }
        @media (max-width: 992px) {
          .blog-title {
            font-size: 2.5rem;
          }
        }
        @media (max-width: 768px) {
          .blog-content {
            padding: 2rem 0;
          }
          .blog-title {
            font-size: 2.2rem;
          }
          .blog-meta {
            flex-direction: column;
            gap: 1rem;
          }
          .similar-blog {
            flex-direction: column;
            align-items: center;
            text-align: center;
          }
          .similar-blog-image {
            width: 100%;
            height: 150px;
          }
          .similar-blog-content {
            padding: 1rem 0;
            align-items: center;
          }
        }
        @media (max-width: 576px) {
          .blog-title {
            font-size: 1.8rem;
          }
        }
      `}</style>
      <Footer />
    </>
  );
};
export default DeatailBlog1;
